import { render, staticRenderFns } from "./HistoryTableView.vue?vue&type=template&id=1346c338&scoped=true"
import script from "./HistoryTableView.vue?vue&type=script&lang=js"
export * from "./HistoryTableView.vue?vue&type=script&lang=js"
import style0 from "./HistoryTableView.vue?vue&type=style&index=0&id=1346c338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1346c338",
  null
  
)

export default component.exports